import { INode } from "../../@types/device";

/** A half-filled or console-edited record degrades to this, never a crash. */
export default function UnknownWidget({ node }: { node: INode }) {
  return (
    <div className="mt-4 text-sm text-amber-500">
      <i className="fas fa-triangle-exclamation mr-2" />
      Unsupported widget: {String(node.widget ?? "(none)")}
    </div>
  );
}
